const state = () => {
    return {
        menu: [
            {
                pageName: 'Main',
                title: 'Главная',
                props: {targetBlock: 'hero'}
            },
            {
                pageName: 'Main',
                title: 'Новости',
                props: {targetBlock: 'news'}
            },
            {
                pageName: 'Main',
                title: 'НПА',
                props: {targetBlock: 'legalActsBlock'}
            },
            {
                pageName: 'Main',
                title: 'Цифровые инструменты',
                props: {targetBlock: 'digitalTools'}
            },
            {
                pageName: 'Main',
                title: 'Участники АИЦ',
                props: {targetBlock: 'partnersBlock'}
            },
            {
                pageName: 'Main',
                title: 'Контакты',
                props: {targetBlock: 'contact'}
            },
        ]
    }
}

// getters
const getters = {
    menu: state => state.menu
}

// actions
const actions = {}

// mutations
const mutations = {}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
